
import {getInstitution} from '@/services/institution/index'


const state = {
  institution:{}
}

const mutations = {
  setInstitution(state, payload) {
    state.institution = payload
  }
}

const getters = {
  getInstitution: function (state) {
    return state.institution
  },
}

const actions = {
  actionSetInstitution({commit},id) {
    return new Promise((resolve, reject) => {
      getInstitution(id).then(response => {
        commit('setInstitution', response.data)
        resolve(response);
      }, error => {
        reject(error);
      })
    })
  },


}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true
}
